


import React, { useEffect, useState } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './UserList.css';
import BottomSheet from '../components/BottomSheet';
import '../components/BottomSheet.css';
import NavBarTop from '../components/NavBarTop';

const UserList = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let role = params.get('role') || '';
  // Normalize role for API
  if (role === 'physiotherapist' || role === 'physio' || role === 'doctor') role = 'physiotherapist';
  else if (role === 'clinic') role = 'clinic';
  else if (role === 'rehab_centre' || role === 'rehab' || role === 'rehabcentre') role = 'rehab_centre';
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginator, setPaginator] = useState({});
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [city, setCity] = useState('');
  const [cities, setCities] = useState([]);
  const [filterSheetOpen, setFilterSheetOpen] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    setLoading(true);
    axios.get(`https://physiodirectory.in/api/public-data`, {
      params: { role, page, search, city }
    })
      .then(res => {
        setUsers((res.data.providers && res.data.providers.data) ? res.data.providers.data : []);
        setPaginator(res.data.providers || {});
        setCities(res.data.cities || []);
      })
      .catch(err => {
        setUsers([]);
        setPaginator({});
        setCities([]);
        window.alert('No users found or API error.');
      })
      .finally(() => setLoading(false));
  }, [role, page, search, city]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
  };

  // Navigation for blue section buttons
  const handleRoleNav = (newRole) => {
    navigate(`/users?role=${newRole}`);
    setPage(1);
  };


  // ProviderCard copied from Home.js for consistent UI
  const ProviderCard = ({ provider, typeLabel }) => {
    const {
      profile_photo_url,
      banner_url,
      city: cityDisplay,
      display_qualification: qual,
      name: rawName,
      role
    } = provider;

    let displayId = provider.profile_id;
    if (!displayId) {
      if (role === 'physiotherapist' && provider.physiotherapist_profile) displayId = provider.physiotherapist_profile.profile_id;
      else if (role === 'clinic' && provider.clinic_profile) displayId = provider.clinic_profile.profile_id;
      else if (role === 'rehab_center' && provider.rehab_center_profile) displayId = provider.rehab_center_profile.profile_id;
    }
    if (!displayId && provider.id) {
      displayId = `PHY00${provider.id}`;
    } else if (displayId && !isNaN(displayId)) {
      displayId = `PHY00${displayId}`;
    }
    if (displayId && String(displayId).startsWith('PHY') && !String(displayId).startsWith('PHY00')) {
      // ok
    } else if (displayId && !String(displayId).startsWith('PHY') && !String(displayId).startsWith('#')) {
      displayId = `PHY00${displayId}`;
    }

    const displayName = role === 'physiotherapist'
      ? `${provider.physiotherapist_profile?.prefix ? provider.physiotherapist_profile.prefix : ''} ${rawName.replace(/\sPT$/i, ' (PT)')}`
      : rawName.replace(/^Dr\.?\s*/i, '').replace(/\sPT$/i, '');

    const fallbackBanner = 'https://physiodirectory.in/assets/images/pd_bgm.png';
    const fallbackAvatar = typeLabel === 'Physiotherapist'
      ? 'https://physiodirectory.in/assets/images/pd_image.png'
      : (typeLabel === 'Physio Clinic' ? 'https://physiodirectory.in/assets/images/clinic.png' : 'https://physiodirectory.in/assets/images/rahab.png');

    return (
      <div className="card provider-card-modern h-100 shadow-sm border-0 bg-white mb-3">
        <div className="card-banner overflow-hidden position-relative" style={{height: '140px'}}>
          <img
            src={banner_url || fallbackBanner}
            alt="Banner"
            className="w-100 h-100 object-fit-cover"
            onError={e => { e.target.onerror = null; e.target.src = fallbackBanner; }}
          />
        </div>
        <div className="card-body p-3 d-flex flex-column bg-white">
          <div className="d-flex align-items-start mb-3">
            <div className="position-relative me-3 flex-shrink-0" style={{width: '60px', height: '60px'}}>
              <img
                src={profile_photo_url || fallbackAvatar}
                alt={displayName}
                className="rounded-circle bg-white shadow-sm"
                style={{ width: '100%', height: '100%', objectFit: 'cover', padding: '3px' }}
                onError={e => { e.target.onerror = null; e.target.src = fallbackAvatar; }}
              />
            </div>
            <div className="flex-grow-1 pt-1 overflow-hidden">
              <h5 className="fw-bold mb-1 text-dark text-truncate" style={{fontSize: '1.05rem', color: '#2d3748'}}>
                {displayName}
              </h5>
              <div className="d-flex flex-column align-items-start gap-1">
                <span className="badge bg-primary-subtle text-primary fw-medium rounded-2 px-2 py-1" style={{fontSize: '0.7rem'}}>
                  {typeLabel}
                </span>
                <small className="text-muted" style={{fontSize: '0.75rem'}}>ID: {displayId}</small>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <p className="text-muted small mb-1 d-flex align-items-center">
              <i className="bi bi-geo-alt-fill me-2 text-primary"></i>
              <span className="text-truncate">{cityDisplay && cityDisplay !== 'N/A' ? cityDisplay : 'Location N/A'}</span>
            </p>
            {qual && (
              <p className="text-muted small mb-0 d-flex align-items-center">
                <i className="bi bi-award me-2 text-primary"></i>
                <span className="text-truncate">{qual}</span>
              </p>
            )}
          </div>
          <Link to={`/provider/${provider.id}`} className="btn btn-outline-primary w-100 rounded-pill fw-semibold mt-auto btn-sm" style={{fontSize: '0.9rem'}}>
            View Profile <i className="bi bi-arrow-right ms-1"></i>
          </Link>
        </div>
      </div>
    );
  };

  return (
    <div className="mobile-page-container bg-light min-vh-100">
      <NavBarTop
        title={
          role === 'physiotherapist' ? 'All Physiotherapists' :
          role === 'clinic' ? 'All Physio Clinics' :
          role === 'rehab_centre' || role === 'rehab_center' ? 'All Rehab Centres' :
          'All Providers'
        }
        right={
          <button className="btn btn-link p-0" style={{fontSize: '1.5rem'}} onClick={() => setFilterSheetOpen(true)}>
            <i className="bi bi-funnel"></i>
          </button>
        }
      />
      {/* Bottom Sheet for Filters */}
      <BottomSheet open={filterSheetOpen} onClose={() => setFilterSheetOpen(false)}>
        <div className="mb-3">
          <label className="form-label fw-bold">Location</label>
          <div className="d-flex align-items-center">
            <i className="bi bi-geo-alt-fill me-1 small text-primary"></i>
            <select 
              className="form-select custom-city-select"
              value={city}
              onChange={e => { setCity(e.target.value); setPage(1); }}
            >
              <option value="">All Cities</option>
              {cities.map((c, idx) => (
                <option key={idx} value={c}>{c}</option>
              ))}
            </select>
          </div>
        </div>
        <form onSubmit={handleSearch} className="mb-3">
          <label className="form-label fw-bold">Search</label>
          <div className="search-input-wrapper">
            <i className="bi bi-search"></i>
            <input 
              type="text" 
              className="form-control modern-search-input" 
              placeholder="Search Doctors, Clinics..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
        </form>
        <div className="category-scroll-container mt-3 mb-0 ps-0">
          <button className={`category-pill ${role === 'physiotherapist' ? 'active' : ''}`} onClick={() => handleRoleNav('physiotherapist')}>Physiotherapists</button>
          <button className={`category-pill ${role === 'clinic' ? 'active' : ''}`} onClick={() => handleRoleNav('clinic')}>Clinic</button>
          <button className={`category-pill ${role === 'rehab_center' ? 'active' : ''}`} onClick={() => handleRoleNav('rehab_center')}>Rehab</button>
        </div>
      </BottomSheet>
      <div className="container py-2">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : (
          <>
            <div className="row g-3">
              {users.map(user => (
                <div className="col-12" key={user.id}>
                  <ProviderCard provider={user} typeLabel={role === 'physiotherapist' ? 'Physiotherapist' : (role === 'clinic' ? 'Physio Clinic' : (role === 'rehab_centre' ? 'Rehab Centre' : 'Provider'))} />
                </div>
              ))}
              {users.length === 0 && <div className="text-center text-muted py-5">No users found.</div>}
            </div>
            {/* Compact Pagination */}
            {paginator && paginator.last_page > 1 && (
              <nav className="d-flex justify-content-center mt-4 overflow-auto userlist-pagination-nav">
                <ul className="pagination pagination-sm mb-0 flex-nowrap">
                  <li className={`page-item${paginator.current_page === 1 ? ' disabled' : ''}`}>
                    <button className="page-link" onClick={() => setPage(page - 1)} disabled={paginator.current_page === 1}>Prev</button>
                  </li>
                  {/* Show first page */}
                  {paginator.current_page > 3 && (
                    <li className="page-item"><button className="page-link" onClick={() => setPage(1)}>1</button></li>
                  )}
                  {/* Ellipsis before */}
                  {paginator.current_page > 4 && (
                    <li className="page-item disabled"><span className="page-link">...</span></li>
                  )}
                  {/* Pages around current */}
                  {Array.from({length: paginator.last_page}, (_, idx) => idx + 1)
                    .filter(num => Math.abs(num - paginator.current_page) <= 2)
                    .map(num => (
                      <li key={num} className={`page-item${paginator.current_page === num ? ' active' : ''}`}>
                        <button className="page-link" onClick={() => setPage(num)}>{num}</button>
                      </li>
                  ))}
                  {/* Ellipsis after */}
                  {paginator.current_page < paginator.last_page - 3 && (
                    <li className="page-item disabled"><span className="page-link">...</span></li>
                  )}
                  {/* Show last page */}
                  {paginator.current_page < paginator.last_page - 2 && (
                    <li className="page-item"><button className="page-link" onClick={() => setPage(paginator.last_page)}>{paginator.last_page}</button></li>
                  )}
                  <li className={`page-item${paginator.current_page === paginator.last_page ? ' disabled' : ''}`}>
                    <button className="page-link" onClick={() => setPage(page + 1)} disabled={paginator.current_page === paginator.last_page}>Next</button>
                  </li>
                </ul>
              </nav>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default UserList;
